import React from 'react';
import {connect} from 'react-redux';
import ReactTable from "react-table";
import _ from 'lodash';
import Logger, {LOG_LEVELS} from '../../utils/logger';
import LanguageStringResolver from '../fields/language/LanguageStringResolver';
import FormattedCurrencyValue from '../fields/number/FormattedCurrencyValue';
import NoData from '../page/NoData';
import Pagination from '../page/Pagination'
import { withFullStoryExclude } from '../../utils/fullStoryHelper';

const log = new Logger('DATA_MINING_DETAILS', LOG_LEVELS.DEBUG);
const SENSITIVE_COLUMNS =  
    [ 'Amount', 'Amount VAT', 'Amount VAT Reversed', 
      'Total Value Excl VAT', 'Total Value Excl VAT 2', 'Total Value Excl VAT 3','Total Value Excl VAT 4','Total Value Excl VAT 5',
      'Total value','Total value 2','Total value 3','Total value 4','Total value 5',
      'VAT Amount','VAT Amount 2','VAT Amount 3','VAT Amount 4','VAT Amount 5', 'Intrastat In', 'Intrastat Out', 'EC Listing', 'Deductible VAT', 'Good Type', 'Main VAT Code'];
export class DataMiningDetails extends React.Component {

    getColumns() {
        log.debug('render(): ',this.props.reportType);
        var columnData = this.props.columnData || [];;

        log.debug('render(): columnData',columnData);

        const columns = columnData.map((item, id)=>{
            log.debug('render(): item',item,item.Accessor,item.Header);
           return {
                id : item.Accessor,
                Header: props => <LanguageStringResolver string={item.Header}/>,
                accessor: ((item.Accessor === 'Amount') || (item.Accessor === 'Amount VAT') || (item.Accessor === 'Amount VAT Reversed') || (item.Accessor === 'Amount VAT Deducted') || (item.Accessor === 'Commercial Value') || (item.Accessor === 'Statistical Value') || (item.Accessor === 'Total Value Excl VAT') || (item.Accessor === 'Total Value Excl VAT 2') || (item.Accessor === 'Total Value Excl VAT 3' ) || (item.Accessor === 'Total Value Excl VAT 4' ) || (item.Accessor === 'Total Value Excl VAT 5' ) || (item.Accessor === 'Total value' ) || (item.Accessor === 'Total value 2' ) || (item.Accessor === 'Total value 3' ) || (item.Accessor === 'Total value 4' ) || (item.Accessor === 'Total value 5' ) || (item.Accessor === 'Currency' ) || (item.Accessor === 'Currency 2' ) || (item.Accessor === 'Currency 3' ) || (item.Accessor === 'Currency 4' ) || (item.Accessor === 'Currency 5' ) || (item.Accessor === 'VAT Amount' ) || (item.Accessor === 'VAT Amount 2' ) || (item.Accessor === 'VAT Amount 3' ) || (item.Accessor === 'VAT Amount 4' ) || (item.Accessor === 'VAT Amount 5' )) ?
                    d => <FormattedCurrencyValue value={d[item.Accessor]}></FormattedCurrencyValue> : item.Accessor,
                filterable : item.Filterable,
                style: item.textAlign !== undefined ? {textAlign: "right"} : "",
                maxWidth :  item.MaxWidth !== undefined ? item.MaxWidth : 1000,
                headerClassName:  item.headerClassName || (SENSITIVE_COLUMNS.includes(item.Accessor) ? withFullStoryExclude() : ''),
                className: item.className ||  (SENSITIVE_COLUMNS.includes(item.Accessor) ? withFullStoryExclude() : '')
            }
        })
        log.debug('render(): ',columns);
        return columns;
    }

    render() {
        log.debug('render(): ');
        const columns = this.getColumns();

        const NoDataComponent = props => (
            <NoData
              noDataText="transactionReports_NoData"
              {...props}
            />
          )

        return (
            <ReactTable
                defaultPageSize={this.props.defaultPageSize || 1000}
                minRows={0}
                maxRows={0}
                manual
                data={this.props.data}
                columns={columns}
                loading={this.props.loading} // Display the loading overlay when we need it
                onFetchData={this.props.onFetchData} // Request new data when things change
                showPageJump={false}
                pages={this.props.pages}
                pageSizeOptions={this.props.pageSizeOptions || [ 1000, 2000, 5000, 10000]}
                NoDataComponent={NoDataComponent}
                className={_.isEmpty(this.props.filterOption) && _.isEmpty(this.props.data) ? 'mb30 hide-header' : 'mb30'}
                PaginationComponent={Pagination}
                showPagination={this.props.data.length === 0 ? false : true}
            />
        )
    }
}

function mapStateToProps(state) {
    log.debug('mapStateToProps: ', state);
    return {
        languages: state.languages
    };
}


export default connect(mapStateToProps)(DataMiningDetails);
